import React from "react";
import AuthPage from "../Auth/Authpage";

const LoginRegister = () => {
  return (
    <div>
      <AuthPage />
    </div>
  );
};

export default LoginRegister;